import { SVGProps } from 'react';

export default function MergeTrainerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.929 23.5415C19.5983 23.5415 22.5729 20.5669 22.5729 16.8976C22.5729 13.2283 19.5983 10.2538 15.929 10.2538C12.2597 10.2538 9.28516 13.2283 9.28516 16.8976C9.28516 20.5669 12.2597 23.5415 15.929 23.5415ZM13.7147 16.8977C14.9378 16.8977 15.9293 15.9061 15.9293 14.683C15.9293 13.4599 14.9378 12.4684 13.7147 12.4684C12.4916 12.4684 11.5001 13.4599 11.5001 14.683C11.5001 15.9061 12.4916 16.8977 13.7147 16.8977Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.29 23.5415C43.9593 23.5415 46.9338 20.5669 46.9338 16.8976C46.9338 13.2283 43.9593 10.2538 40.29 10.2538C36.6207 10.2538 33.6461 13.2283 33.6461 16.8976C33.6461 20.5669 36.6207 23.5415 40.29 23.5415ZM38.0755 16.8977C39.2986 16.8977 40.2901 15.9061 40.2901 14.683C40.2901 13.4599 39.2986 12.4684 38.0755 12.4684C36.8524 12.4684 35.8609 13.4599 35.8609 14.683C35.8609 15.9061 36.8524 16.8977 38.0755 16.8977Z"
        fill="inherit"
      />
      <path
        d="M37.3508 17.434C37.887 17.0936 38.4746 16.8977 39.0342 16.8977C40.158 16.8977 40.895 17.7278 40.895 18.7071C40.895 19.3694 40.5451 20.0549 39.948 20.4328L38.2057 21.5633C35.1818 23.5947 29.7703 28.6612 29.7703 34.053V37.5076H29.7584V40.5827C29.7584 43.7915 28.5163 46.2538 27.858 46.2538C27.1892 46.2538 25.9382 43.7739 25.9382 40.5827V37.1805H25.9466V34.053C25.9466 28.6612 20.5585 23.5715 17.5113 21.5632L15.769 20.4328C15.1486 20.0549 14.822 19.3926 14.822 18.7304C14.822 17.6579 15.5775 16.8977 16.678 16.8977C17.2424 16.8977 17.83 17.0936 18.3614 17.434L19.498 18.1917C22.5819 20.2602 27.0605 24.9569 27.8117 27.2533H27.8773C28.6564 24.9337 33.1584 20.2602 36.219 18.1917L37.3508 17.434Z"
        fill="inherit"
      />
    </svg>
  );
}
